import React, { useState, useContext } from "react";
import { useNavigate } from 'react-router-dom';
import { Form, Button, Card, Container, Alert } from 'react-bootstrap';
import { AppContext } from "../context/appContext";
import { Auth } from "aws-amplify";

function ForgotPassword() {
  const { setGlobalLoading } = useContext(AppContext);
  const [username, setUsername] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const navigate = useNavigate();

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    try {
      setGlobalLoading(true);
      // Initiate the password reset process
      await Auth.forgotPassword(username.toLowerCase());
      setSuccess('Password reset code has been sent to your email. Please check your inbox.');
      // Navigate to the reset password confirmation page with the username
      navigate(`/reset-password-confirm?username=${encodeURIComponent(username.toLowerCase())}`);
      setGlobalLoading(false);
    } catch (error) {
      console.error('Forgot password error:', error);
      setError(error.message || 'An error occurred while sending the reset code');
      setGlobalLoading(false);
    }
  };

  return (
    <Container
      className="d-flex align-items-center justify-content-center"
      style={{ minHeight: "100vh" }}>
      <Card
        className="shadow"
        style={{ maxWidth: "400px", width: "100%", borderRadius: "10px" }}>
        <Card.Body>
          <h2>Forgot Your Password</h2>
          <div className="text-center mb-4">
            <img
              src="/faithwelcomeback.png"
              alt="Welcome"
              style={{ maxWidth: "100%", height: "auto", borderRadius: "8px" }}
            />
          </div>
          {error && <Alert variant="danger">{error}</Alert>}
          {success && <Alert variant="success">{success}</Alert>}
          <Form onSubmit={handleForgotPassword}>
            <Form.Group className="mb-3" controlId="username">
              <Form.Label>Email address</Form.Label>
              <Form.Control
                type="email"
                placeholder="Enter your email address"
                value={username}
                onChange={(e) => setUsername(e.target.value.toLowerCase())}
                required
              />
              <Form.Text className="text-muted">
                We'll send a password reset code to this email address.
              </Form.Text>
            </Form.Group>

            <div className="d-grid gap-2">
              <Button variant="primary" type="submit" className="rounded-pill btn-accent">
                Send Reset Code
              </Button>
              <div>
                Remember your password?{" "}
                <span
                  style={{
                    color: "#0d6efd",
                    cursor: "pointer"
                  }}
                  onClick={() => navigate("/login")}>
                  Back to login
                </span>
              </div>
            </div>
          </Form>
        </Card.Body>
      </Card>
    </Container>
  );
}

export default ForgotPassword; 